// Using a singleton pattern here so we have _one_ registry shared by all in the same app.


class RendererRegistry {
  constructor(){
    this._registry = {};
  }

  register(key:string, renderer:any):void {
    this._registry[key] = renderer
  }

  find(key:string):any {
    return this._registry[key]
  }
}

const instance = new RendererRegistry();
Object.freeze(instance);

export default instance;
